import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Default pickup workflow ID.
 */
export const schema = z.number().int().positive();

export type DefaultPickupWorkflowId = z.infer<typeof schema>;

export const definition = define({
  key: 'default_pickup_workflow_id',
  schema,
  label: 'Default Pickup Workflow ID',
  description: 'Default pickup workflow ID. Auto-populated from workflowset selection.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.WORKFLOWS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 1,
});
